export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NOTIFICATION_RECEIVED: 'NOTIFICATION_RECEIVED',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  // The table layout hides the conversation list but keeps it mounted, so its
  // toolbar drives the list's own filter handlers through the bus rather than
  // re-implementing them.
  TABLE_APPLY_FILTERS: 'tableApplyFilters',
  TABLE_RESET_FILTERS: 'tableResetFilters',
  TABLE_BASIC_FILTER_CHANGE: 'tableBasicFilterChange',
  // A ticket was opened against the current conversation from any surface
  // (header quick action or the Details panel); the panel's list refetches.
  SUPPORT_CASE_LINKS_UPDATED: 'SUPPORT_CASE_LINKS_UPDATED',
};
